import { Component, OnInit, OnDestroy, effect, signal } from '@angular/core';
import { ConversationService } from '../../../../../../shared/services/conversation/conversation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf, CommonModule } from '@angular/common';
import { url } from 'inspector';

interface NavigationConfig {
  enableChatMode: boolean;
  isConversationProgressBar: boolean;
  progressbarColor: string;
  buttonBelowInteraction: boolean;
  autoMoveToNextPage: boolean;
  enableBrowserBack: boolean;
  nextButtonColor: string;
  nextButtonTextColor: string;
  enableBackButton: boolean;
  backButtonColor: string;
  backButtonTextColor: string;
}

interface HeaderConfig {
  enableHeader: boolean;
  headerTitle: string;
  headerBackgroundColor: string;
  headerTextColor: string;
  enableHeaderLogo: boolean;
  headerLogoUrl: string;
  headerPosition: 'left' | 'center' | 'right';
  version?: string;
  label?: string;
  is_fixed?: boolean;
}

interface FooterConfig {
  enableFooter: boolean;
  footerBackgroundColor: string;
  footerTextColor: string;
  showLogoInFooter: boolean;
  footerLogoUrl: string;
}

@Component({
  selector: 'app-litmus-intraction-navigation',
  templateUrl: './litmus-intraction-navigation.component.html',
  styleUrl: './litmus-intraction-navigation.component.scss',
  standalone: true,
  imports: [FormsModule, NgIf, ReactiveFormsModule, CommonModule]
})
export class LitmusIntractionNavigationComponent implements OnInit, OnDestroy {

  navigationConfig: NavigationConfig = {
    enableChatMode: false,
    isConversationProgressBar: false,
    progressbarColor: '#66b846',
    buttonBelowInteraction: true,
    autoMoveToNextPage: false,
    enableBrowserBack: true,
    nextButtonColor: '#008000',
    nextButtonTextColor: '#ffffff',
    enableBackButton: false,
    backButtonColor: '#008000',
    backButtonTextColor: '#ffffff'
  };

  headerConfig: HeaderConfig = {
    enableHeader: true,
    headerTitle: '',
    headerBackgroundColor: '#296dc1',
    headerTextColor: '#ffffff',
    enableHeaderLogo: false,
    headerLogoUrl: '',
    headerPosition: 'left'
  };

  footerConfig: FooterConfig = {
    enableFooter: true,
    footerBackgroundColor: '#222',
    footerTextColor: '#ffffff',
    showLogoInFooter: false,
    footerLogoUrl: ''
  };



  uploadFooterImageName: string = '';
  uploadHeaderImageName: string = '';

  selectedFile: File | null = null;
  imageFooterSrc: string | undefined;
  imageHeaderSrc: string | undefined;
  userVisited: boolean = false;
  private destroy$ = new Subject<void>();
  private tempFileObject: File[] = [];
  conversationObject: any = null;
  headerLogoDetail: any = {
    filename: '',
    url: ''
  }
  footerLogoDetail: any = {
    filename: '',
    url: ''
  }

  compareData: any = {};
  isUserHasWriteAccess: boolean = false;
  constructor(private _conversation: ConversationService) {
    effect(() => {
      let conversationObject: any = this._conversation.conversationObject();
      this.isUserHasWriteAccess = this._conversation.isUserHasWriteAccess('MANAGE_CONVERSATION');
      if (conversationObject) {
        const fileObject = this._conversation.getFiles();
        
        this.conversationObject = conversationObject;
        this.uploadFooterImageName = '';
        this.uploadHeaderImageName = '';
        // Watch for header config changes
        if (!this.isHeaderConfigChanged) {
          if (!this.headerConfig.headerTitle) {
            this.headerConfig.headerTitle = this._conversation.brand_detail.name;
          }
          if (conversationObject?.configuration?.header) {
            this.headerConfig = { ...this.headerConfig, ...conversationObject.configuration.header };
            this.imageHeaderSrc = this.headerConfig.headerLogoUrl;
            this.getLogoContainerContent('footer');
          } else {
            // this._conversation.configuration.header = this.headerConfig;
          }
          if (this.headerConfig?.headerLogoUrl) {
            this.prepareLogoDetail(this.headerConfig.headerLogoUrl, 'header')
          }
          this.compareData['header'] = Helpers.deepClone(this.headerConfig);
        }else{
          const headerFile = fileObject.find((file:any)=>file.id == 'header');
          if(headerFile){
            this.uploadHeaderImageName = headerFile.file.name;
          }
        }


        // Watch for footer config changes
        if (!this.isFooterConfigChanged) {
          if (conversationObject?.configuration?.footer) {
            this.footerConfig = { ...this.footerConfig, ...conversationObject.configuration.footer };
            this.footerConfig.footerBackgroundColor = this.footerConfig.footerBackgroundColor || '#222';
            this.footerConfig.footerTextColor = this.footerConfig.footerTextColor || '#ffffff';
            this.imageFooterSrc = this.footerConfig.footerLogoUrl;
            this.getLogoContainerContent('footer');
          } else {
            // this._conversation.configuration.footer = this.footerConfig;
          }
          if (this.footerConfig?.footerLogoUrl) {
            this.prepareLogoDetail(this.footerConfig.footerLogoUrl, 'footer')
          }

          this.compareData['footer'] = Helpers.deepClone(this.footerConfig);
        }else{
          const footerFile = fileObject.find((file:any)=>file.id == 'footer');
          if(footerFile){
            this.uploadFooterImageName = footerFile.file.name;
          }
        }



        // Watch for navigation config changes
        if (!this.isNavigationConfigChanged) {
          if (conversationObject?.configuration?.navigation) {
            this.navigationConfig = { ...this.navigationConfig, ...conversationObject.configuration.navigation };
            this.navigationConfig.enableBrowserBack = conversationObject.configuration.enable_back_button;
          } else {
            // this._conversation.configuration.navigation = this.navigationConfig;
          }
          this.compareData['navigation'] = Helpers.deepClone(this.navigationConfig);
        }
      }
    })
  }

  ngOnInit(): void {
    this.loadConfiguration();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadConfiguration(): void {
    if (this._conversation?.configuration) {
      if (this._conversation?.configuration.header) {
        this.headerConfig = { ...this.headerConfig, ...this._conversation.configuration.header };
        this.imageHeaderSrc = this.headerConfig.headerLogoUrl;
        this.headerConfig.headerTitle = this._conversation.getLabelById(this._conversation.default_language, "label-header") || '';

        if (this._conversation.brand_detail && this.headerConfig.headerTitle === "Provide label for header") {
          this.headerConfig.headerTitle = this._conversation.brand_detail.name || '';
        }

        if (!this.headerConfig.headerTitle && this._conversation.brand_detail) {
          this.headerConfig.headerTitle = this._conversation.brand_detail.name || '';
        }

        if (this.headerConfig.enableHeader) {
          const headerLabelId = this._conversation.configuration.header.label;
          this._conversation.setLabelById(this._conversation.default_language, headerLabelId, this.headerConfig.headerTitle);

        }
      }
      if (this._conversation.configuration.footer) {
        this.footerConfig = { ...this.footerConfig, ...this._conversation.configuration.footer };
        this.imageFooterSrc = this.footerConfig.footerLogoUrl;
        this.getLogoContainerContent('footer');
      }

      if (this._conversation.configuration.navigation) {
        this.navigationConfig = { ...this.navigationConfig, ...this._conversation.configuration.navigation };
        this._conversation.configuration.auto_navigation_to_next_page = this.navigationConfig.autoMoveToNextPage;
        this._conversation.configuration.enable_back_button = this.navigationConfig.enableBrowserBack;
        this._conversation.configuration.footer_style.is_per_group = this.navigationConfig.buttonBelowInteraction;
      }

      this._conversation.set(this._conversation.configuration);
    }
  }

  prepareLogoDetail(logoUrl: string, type: 'header' | 'footer') {
    let urlArr = logoUrl.split('/')
    if (type == 'header') {
      this.headerLogoDetail = {
        filename: urlArr[urlArr.length - 1],
        url: logoUrl
      }
    }
    if (type == 'footer') {
      this.footerLogoDetail = {
        filename: urlArr[urlArr.length - 1],
        url: logoUrl
      }
    }
    // console.log("this.headerLogoDetail", this.headerLogoDetail)
    // console.log("this.footerLogoDetail", this.footerLogoDetail)
  }

  validateConversationProgressBar(Event, flag): Boolean | void {
    if (this.conversationObject.hasOwnProperty('configuration') && flag) {
      var def_device = this.conversationObject['configuration'].default_device || "desktop";
      var def_language = this.conversationObject['configuration'].default_language || "english";
      var screens = this.conversationObject['configuration'].screens[def_device][def_language];
      var groups = screens.filter(function (group) {
        return (group.is_rating_page === true && group.calculate_for_progress === true);
      });
      if (groups.length <= 1) {
        this.navigationConfig.isConversationProgressBar = false;
        Helpers.smallAlertBox("Error", 'Conversation progress bar can be configured for more than 1 page conversation.', "error", 3500);
        return false;
      }
      if (flag) {
        this.navigationConfig.isConversationProgressBar = flag;
      }
    }
  }


  onFileSelect(event: any, uploadFor: string): void {
    const file = event.target.files[0];
    if (file) {
      const MAX_SIZE = 51200; // 50KB
      const MAX_DIMENSION = 23;

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Helpers.smallAlertBox("Image size exceeded", "File type is not supported, please upload an image of the type .png or .jpg or .jpeg", "error", 5000);
        return;
      }

      if (file.size > MAX_SIZE) {
        Helpers.smallAlertBox("Image size exceeded", "File size of more than 50 Kb is not supported, please upload an image that does not exceed 50 Kb", "error", 5000);
        return;
      }

      const img = new Image();
      img.src = window.URL.createObjectURL(file);

      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        window.URL.revokeObjectURL(img.src);

        if (width <= MAX_DIMENSION && height <= MAX_DIMENSION) {
          this.selectedFile = file;
          if (uploadFor == 'header') {
            this.uploadHeaderImageName = file.name
          }
          if (uploadFor == 'footer') {
            this.uploadFooterImageName = file.name

          }
          this._conversation.setFile({
            id: uploadFor,
            file: file
          });
        } else {
          Helpers.smallAlertBox("Error", 'Image resolution of more than 23*23 pixels is not supported, please upload an image with a resolution that does not exceed 23*23 pixels', 'error', 5000);
        }
        this.makeDirty(uploadFor);
      };
    }
    
  }

  clearFileInput(input: any, removeFrom: string): void {
    input.value = '';
    if (removeFrom == 'header') {
      this.uploadHeaderImageName = '';
      this._conversation.removeFile({ id: 'header' });
    }
    if (removeFrom == 'footer') {
      this.uploadFooterImageName = '';
      this._conversation.removeFile({ id: 'footer' });
    }
  }

  removeImage(removeFrom: string, action?: string): void {
    this.selectedFile = null;

    // if (action) {
    //   this.headerConfig.headerLogoUrl = '';
    // }
    if (removeFrom == 'header') {
      this.imageHeaderSrc = undefined;
      this.uploadHeaderImageName = '';
      this._conversation.removeFile('header');
      this.headerLogoDetail = {
        filename: '',
        url: ''
      }
      this.headerConfig.headerLogoUrl = '';
      
    }
    if (removeFrom == 'footer') {
      this.imageFooterSrc = undefined;
      this.uploadFooterImageName = '';
      this._conversation.removeFile('footer');
      this.footerLogoDetail = {
        filename: '',
        url: ''
      }
       this.footerConfig.footerLogoUrl = '';
    }
    
    this.makeDirty(removeFrom);
    // const conversationObject = this._conversation.get();
    // this._conversation.set(this._conversation.configuration);
  }

  getLogoContainerContent(type: string): string {
    let logoContent: any = 'Logo Size 23x23 pixels';

    if (type == 'header') {
      if (this.imageHeaderSrc || this.uploadHeaderImageName) {
        if (this.uploadHeaderImageName) {
          logoContent = this.uploadHeaderImageName;
        } else {
          logoContent = `<a href="https:${this.headerConfig.headerLogoUrl}" target="_blank" style="font-size: 12px;">https:${this.headerConfig.headerLogoUrl}</a>`;
        }
      }
    } else if (type == 'footer') {
      if (this.imageFooterSrc || this.uploadFooterImageName) {
        if (this.uploadFooterImageName) {
          logoContent = this.uploadFooterImageName;
        } else {
          logoContent = `<a href="https:${this.footerConfig.footerLogoUrl}" target="_blank" style="font-size: 12px;">https:${this.footerConfig.footerLogoUrl}</a>`;
        }
      }
    }

    return logoContent;
  }

  onEnableHeader(): void {
    // if (!this.userVisited) {
    //   this.headerConfig.enableHeader = true;
    // }
    this.userVisited = true;
  }




  // updateConfigs(isPublish: boolean = false): void {
  //   // _.debounce(()=>{
  //   //   // const conversationObject = this._conversation.get();
  //   // if (!this.headerConfig.headerTitle) {
  //   //   this.headerConfig.headerTitle = this._conversation.brand_detail.name;
  //   // }

  //   // if (this.headerConfig.enableHeaderLogo) {
  //   //   if (!this.selectedFile && !this.headerConfig.headerLogoUrl) {
  //   //     Helpers.smallAlertBox("Please upload logo", "You enabled 'Show Brand Logo in Header' option", "error", 5000);
  //   //     return;
  //   //   }
  //   // }

  //   // if (this.footerConfig.showLogoInFooter) {
  //   //   if (this.tempFileObject.length === 0 && !this.footerConfig.footerLogoUrl) {
  //   //     console.error("Please upload logo", "You enabled 'Footer Logo' option");
  //   //     return;
  //   //   }
  //   // }

  //   // this._conversation.configuration.header = { ...this.headerConfig };
  //   // this._conversation.configuration.footer = this.footerConfig;
  //   // console.log("this._conversation.configuration", this._conversation.configuration)
  //   // // this._conversation.set(this._conversation.configuration);
  //   // // this._conversation.saveConversation(isPublish);
  //   // }, 300)
  //   // const conversationObject = this._conversation.get(); 

  //   if (this._conversation?.configuration) {
  //     if (this._conversation.configuration.header?.version || this.userVisited || this._conversation.configuration.header?.enableHeader) {
  //       this._conversation.configuration.header = { ...this.headerConfig };
  //       const headerLabelId = this._conversation.configuration.header.label;
  //       this._conversation.setLabelById(this._conversation.default_language, headerLabelId, this.headerConfig.headerTitle);
  //       this._conversation.configuration.header.is_fixed = this.headerConfig.enableHeader;
  //     } else {
  //       this.headerConfig.enableHeader = false;
  //     }

  //     this._conversation.configuration.footer = this.footerConfig;
  //     if (this._conversation.configuration.footer_style) {
  //       this._conversation.configuration.footer_style.hide_logo = !this.footerConfig.enableFooter;
  //     }
  //   }


  //   if (this.headerConfig.enableHeaderLogo) {
  //     if ((!this.uploadHeaderImageName || this.uploadHeaderImageName == '') && !this.headerConfig.headerLogoUrl) {
  //       Helpers.smallAlertBox("Please upload logo", "You enabled 'Show Brand Logo in Header' option", "error", 5000);
  //       return;
  //     }
  //   }

  //   if (this.footerConfig.showLogoInFooter) {
  //     if ((this.uploadFooterImageName == '' || !this.uploadFooterImageName) && !this.footerConfig.footerLogoUrl) {
  //       console.error("Please upload logo", "You enabled 'Footer Logo' option");
  //       return;
  //     }
  //   }





  // }


  onEnableBrowserBack(): void {
    this._conversation.configuration.enable_back_button = this.navigationConfig.enableBrowserBack;
  }
  isNavigationConfigChanged: boolean = false;
  isHeaderConfigChanged: boolean = false;
  isFooterConfigChanged: boolean = false;
  
  makeDirty(type: string) {
    let currentConfig: any = {};
    let compareConfig: any = {};

    switch (type) {
      case 'navigation':
        currentConfig = Helpers.deepClone(this.navigationConfig);
        compareConfig = Helpers.deepClone(this.compareData['navigation']);
        break;
      case 'footer':
        currentConfig = Helpers.deepClone(this.footerConfig);
        compareConfig = Helpers.deepClone(this.compareData['footer']);
        break;
      case 'header':
        currentConfig = Helpers.deepClone(this.headerConfig);
        compareConfig = Helpers.deepClone(this.compareData['header']);
        break;
      default:
        break;
    }

    if (!_.isEmpty(currentConfig) && !_.isEmpty(compareConfig)) {
      if (type == 'header') {
        // Set dirty flag if config changed OR if new header image is selected
        const configChanged = this.generateHash(compareConfig) !== this.generateHash(currentConfig);
        const hasNewImage = this.uploadHeaderImageName !== '';
        this.isHeaderConfigChanged = configChanged || hasNewImage;
      }
      else if (type == 'footer') {
        // Set dirty flag if config changed OR if new footer image is selected
        const configChanged = this.generateHash(compareConfig) !== this.generateHash(currentConfig);
        const hasNewImage = this.uploadFooterImageName !== '';
        this.isFooterConfigChanged = configChanged || hasNewImage;
      }
      else if (type == 'navigation') {
        // Set dirty flag if config changed
        this.isNavigationConfigChanged = this.generateHash(compareConfig) !== this.generateHash(currentConfig);
      }
    }
  }

  private generateHash(obj): string {
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.map(obj, (val, key) => { return `${key}-${JSON.stringify(val)}` }).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  cancelConfig(type: string) {
    // Reset to original values and clear dirty flags
    // console.log('Cancel clicked');
    switch (type) {
      case 'navigation':
        this.navigationConfig = Helpers.deepClone(this.compareData['navigation']);
        this.isNavigationConfigChanged = false;
        break;
      case 'footer':
        this.footerConfig = Helpers.deepClone(this.compareData['footer']);
        this.isFooterConfigChanged = false;
        break;
      case 'header':
        this.headerConfig = Helpers.deepClone(this.compareData['header']);
        this.isHeaderConfigChanged = false;
        break;
      default:
        break;
    }
  }

  saveConfig(type: string) {
    // Dummy save handler
    if (this._conversation?.configuration) {

      if (type == 'header') {
        if (this._conversation.configuration.header?.version || this.userVisited || this._conversation.configuration.header?.enableHeader) {
          this._conversation.configuration.header = { ...this.headerConfig };
          const headerLabelId = this._conversation.configuration.header.label;
          this._conversation.setLabelById(this._conversation.default_language, headerLabelId, this.headerConfig.headerTitle);
          this._conversation.configuration.header.is_fixed = this.headerConfig.enableHeader;
        } else {
          this.headerConfig.enableHeader = false;
        }

        if (this.headerConfig.enableHeaderLogo) {
          if ((!this.uploadHeaderImageName || this.uploadHeaderImageName == '') && !this.headerConfig.headerLogoUrl) {
            // Helpers.smallAlertBox("Please upload logo", "You enabled 'Show Brand Logo in Header' option", "error", 5000);
            Helpers.smallAlertBox("Brand logo not uploaded in the Header", "Please upload the logo and then click on Save", "error", 5000);
            return;
          }
        }
        const headerEl :any = document.getElementById('headerfileInput');
        if(headerEl){
          headerEl.value = '';
        }
        this._conversation.configuration.header = { ...this.headerConfig };
        this.compareData['header'] = Helpers.deepClone(this.headerConfig);
        this.isHeaderConfigChanged = false;
        this.uploadHeaderImageName = '';
      }

      if (type == 'footer') {
        if (this.footerConfig.showLogoInFooter) {
          if ((this.uploadFooterImageName == '' || !this.uploadFooterImageName) && !this.footerConfig.footerLogoUrl) {
            console.error("Please upload logo", "You enabled 'Footer Logo' option");
            Helpers.smallAlertBox("Brand logo not uploaded in the Footer", "Please upload the logo and then click on Save", "error", 5000);
            return;
          }
        }

        this._conversation.configuration.footer = this.footerConfig;
        if (this._conversation.configuration.footer_style) {
          this._conversation.configuration.footer_style.hide_logo = !this.footerConfig.enableFooter;
        }
        const footerEl :any = document.getElementById('footerfileInput');
        if(footerEl){
          footerEl.value = '';
        }
        this._conversation.configuration.footer = this.footerConfig;
        this.compareData['footer'] = Helpers.deepClone(this.footerConfig);
        this.uploadFooterImageName = '';
        this.isFooterConfigChanged = false;
      }

      if (type == 'navigation') {
        this._conversation.configuration.navigation = this.navigationConfig;
        this.compareData['navigation'] = Helpers.deepClone(this.navigationConfig);
        this.isNavigationConfigChanged = false;
      }
    }





    this._conversation.saveConversation(false,type).then((response) => {
      // this.showEditModal = false;
    })
  }
}
